<template>
    <div class="calendar-container" style="position:relative;">
      <date-picker
        :value="value"
        @input="onInput"
        mode="date"
        is-required
        trim-weeks
        :first-day-of-week="1"
        :step="1"
        :locale="locale"
        :min-date="minDate"
        :max-date="maxDate"
        :masks="masks"
        :columns="1"
        :rows="1"
        :is-expanded="false">
        <template v-slot:header="page">
          <div class="vc-title">{{ page.monthLabel }} {{ page.yearLabel }}</div>
        </template>
        <template v-slot:header-left-button>
          <div class="prevMonth">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </div>
        </template>
        <template v-slot:header-right-button>
          <div class="nextMonth">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </div>
        </template>
      </date-picker>
    </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'Calendar',
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    invalid: {}
  },
  components: {
    DatePicker
  },
  data () {
    return {
      masks: {
        input: 'D MMM YYYY',
        weekdays: 'WWW'
      }
    }
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    invalid_ () {
      return !!this.invalid || false
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
